// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer {
  background-color: #0066cc;
  color: white;
  padding: 20px 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.footer-left {
  display: flex;
  align-items: center;
}

.footer-logo {
  font-size: 24px;
  font-weight: bold;
  color: white;
  text-decoration: none;
  display: flex;
  align-items: center;
  gap: 8px;
}

.footer-center {
  text-align: center;
}

.footer-copyright {
  margin: 0;
  font-size: 14px;
}

.footer-text {
  margin: 5px 0;
  font-size: 12px;
  opacity: 0.9;
}

.footer-right {
  text-align: right;
}

.contact-info {
  font-size: 14px;
}

.contact-info h3 {
  margin: 0 0 8px 0;
  font-size: 16px;
}

.contact-info p {
  margin: 3px 0;
}
.footer-logo-text{
  color: #fff;
}
.footer-logo-icon {
    width: 2.5rem;
    height: 2.5rem;
    background: white;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #2563eb;
    font-size: 1.25rem;
}`, "",{"version":3,"sources":["webpack://./src/components/Footer/Footer.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;AACA;EACE,WAAW;AACb;AACA;IACI,aAAa;IACb,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,kBAAkB;AACtB","sourcesContent":[".footer {\n  background-color: #0066cc;\n  color: white;\n  padding: 20px 40px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n}\n\n.footer-left {\n  display: flex;\n  align-items: center;\n}\n\n.footer-logo {\n  font-size: 24px;\n  font-weight: bold;\n  color: white;\n  text-decoration: none;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.footer-center {\n  text-align: center;\n}\n\n.footer-copyright {\n  margin: 0;\n  font-size: 14px;\n}\n\n.footer-text {\n  margin: 5px 0;\n  font-size: 12px;\n  opacity: 0.9;\n}\n\n.footer-right {\n  text-align: right;\n}\n\n.contact-info {\n  font-size: 14px;\n}\n\n.contact-info h3 {\n  margin: 0 0 8px 0;\n  font-size: 16px;\n}\n\n.contact-info p {\n  margin: 3px 0;\n}\n.footer-logo-text{\n  color: #fff;\n}\n.footer-logo-icon {\n    width: 2.5rem;\n    height: 2.5rem;\n    background: white;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: #2563eb;\n    font-size: 1.25rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
